<template>
  <div :class="`popup-wrapper ${wrapperClass}`">
    <component :is="transitionName" :duration="duration">
      <div
        v-if="show"
        :class="`popup-wrapper__content mobile-none tablet-none ${contentClass}`"
      >
        <slot name="default"></slot>
      </div>
    </component>
    <MobilePopup :show="show" @setShow="close">
      <template>
        <slot name="default"></slot>
      </template>
    </MobilePopup>
  </div>
</template>

<script>
import MobilePopup from "./MobilePopup.vue";

export default {
  components: { MobilePopup },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    transitionName: {
      type: String,
      default: "slide-y-up-transition",
    },
    duration: {
      type: Number,
      default: 300,
    },
    wrapperClass: {
      type: String,
      default: "",
    },
    contentClass: {
      type: String,
      default: "",
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>
